import { useState, useEffect } from "react";
import { LoadQuestionsContext } from "./loadQuestionsContext";
import PropTypes from "prop-types";
import axios from "axios";

export function LoadQuestionsContextProvider({ children }) {
  const [id, setId] = useState();
  const [allQuestions, setAllQuestions] = useState([]);
  const [totalMarks, setTotalMarks] = useState(0);
  const [delIndex, setDelIndex] = useState();

  const apiUrl = import.meta.env.VITE_APP_API;
  const access_token = JSON.parse(localStorage.getItem("faceAuthTokenData"))
    .token.access;

  useEffect(() => {
    async function getAllQuestions() {
      const url = `${apiUrl}/api/exam/admin/exam_question_paper/${id}/`;

      const getData = await axios.get(url, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access_token}`,
        },
      });

      setAllQuestions(getData.data.json_question_paper);
    }

    getAllQuestions();
  }, [access_token, apiUrl, id, delIndex]);

  async function getAllQuestions() {
    const url = `${apiUrl}/api/exam/admin/exam_question_paper/${id}/`;

    const getData = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    });

    setAllQuestions(getData.data.json_question_paper);
  }

  function ShuffleArray(array) {
    let newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  }

  async function ShuffleQuestions() {
    const url = `${apiUrl}/api/exam/admin/exam_question_paper/${id}/`;

    const getData = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access_token}`,
      },
    });

    if (getData.status === 200) {
      let formData = new FormData();

      let questions = ShuffleArray(getData.data.json_question_paper);

      console.log("here is shuffled questions: ", questions);

      formData.append("question_paper", JSON.stringify(questions));

      const patchResult = await axios.patch(url, formData, {
        headers: {
          Authorization: `Bearer ${access_token}`,
        },
      });

      if (patchResult.status === 200) getAllQuestions();
    }
  }

  return (
    <LoadQuestionsContext.Provider
      value={{
        allQuestions,
        setAllQuestions,
        setId,
        getAllQuestions,
        totalMarks,
        setTotalMarks,
        delIndex,
        setDelIndex,
        ShuffleQuestions,
      }}
    >
      {children}
    </LoadQuestionsContext.Provider>
  );
}

LoadQuestionsContextProvider.propTypes = {
  children: PropTypes.any,
};
